<div
    class="betslip-over-ask-pick betslip-over-ask-pick--participant"
    [class.betslip-over-ask-pick--participant--has-market-change]="!!props.overAskPick.changes.marketType">
    <div class="betslip-over-ask-pick__line-0">
        {{ pick.optionName.name }}
    </div>
    <div class="betslip-over-ask-pick__line-1">
        <span class="betslip-over-ask-pick--participant__market_value">{{ getMarket() }}</span>
    </div>
    <div class="betslip-over-ask-pick__line-2">
        <span>
            <span class="betslip-over-ask-pick--participant__fixture_time">{{ pick.fixture.eventDate | date: 'HH:mm' }}</span>
            <span class="betslip-over-ask-pick--event_name">{{ pick.eventName.name }}</span>
        </span>
        <ng-container *ngIf="shouldShowBadge">
            <div class="betslip-over-ask-pick__market-badge">
                <span class="betslip-over-ask-pick__market_current_value">{{ getCounterOfferMarket() }}</span>
                <span class="betslip-over-ask-pick__market_prev_value">{{ getInitialMarket() }}</span>
            </div>
        </ng-container>
    </div>
    <div class="betslip-over-ask-pick__changes">
        <ng-content select="[price-changes]"></ng-content>
    </div>
    <div class="betslip-over-ask-pick__remove-container">
        <ng-content select="[remove-button]"></ng-content>
    </div>
    <div class="betslip-over-ask-pick__winnings">
        <ng-content select="[multi-single-possible-winnings]"></ng-content>
    </div>
</div>
